 
/* eslint-disable new-cap */
import $ from 'jquery';
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import {HTTP_STATUS_NOCONTENT, HTTP_STATUS_OK} from '../../../smartpak/httpstatus';
import cartItemViewModelFactory from './cartitemviewmodelfactory';
import events from '../cart/events';
import shoppingCart from '../api/shoppingcart';
import {spRemoveFromCart} from '../../../vendor/googletagmanager/spevents/spremovefromcart';
import {formatCartItemsForEvents} from '../../../vendor/googletagmanager/spevents/checkoutformatters';
import applePayHelper from '../../applepay/applepayhelper';
import { PORTIONPAK, SMARTPAK } from '../../../constants/producttypes';

function CartItemsViewModel(model, customerIsSmartPrimeEligible, onUpdateCallback, ShowOneTimeShipSmartPakOption) {
    var mapping = {
        CartItems: {
            create: function (options) {
                return cartItemViewModelFactory(options.data, customerIsSmartPrimeEligible, onUpdateCallback);
            }
        }
    };

    ko.mapping.fromJS(model, mapping, this);

    this.canShowEstimatedArrival = ko.observable(true);

    this.currentFocus = ko.observable();

    this.showProp65Warnings = ko.observable(false);

    this.cartMessaging = ko.observable();

    this.hasOneTimeShipSmartPakOption = ShowOneTimeShipSmartPakOption;

    this.isRemovingItem = ko.observable(false);

    this.removeItem = this.removeOrMoveItem(shoppingCart.removeItem, cartItem => cartItem.ItemId());

    this.displayApplePay = applePayHelper.displayApplePay;

    this.cartIsEmpty = ko.computed(() => {
        var hasItems = this.CartItems().length === 0;

        if (hasItems) {
            this.cartMessaging('There are no items in your cart');
        }

        return hasItems;
    });

    this.supplyItemsAreAutoShipValid = ko.observable(true);

    this.validateAutoShipSupplyItems = function () {
        var invalidItems = this.CartItems().filter(invalidSupplyAutoShipItem);

        if (invalidItems.length) {
            invalidItems.forEach(function (cartItem) {
                cartItem.validateAutoShip();
            });
        }

        this.supplyItemsAreAutoShipValid(invalidItems.length === 0);
    };

    this.customerFirstName = smartPak.cdProfileCookie.CustomerFirstName;
    this.onUpdateCallback = onUpdateCallback;
    this.customerIsSmartPrimeEligible = customerIsSmartPrimeEligible;

    this.hasSmartPak = function () {
        return this.CartItems().some(function (item) {
            return item.isSmartPak;
        });
    };
}

CartItemsViewModel.prototype.containsAutoShipItems = function () {
    return this.CartItems().some(cartItem => {
        return cartItem.IsAutoShip() || new RegExp(`${SMARTPAK}|${PORTIONPAK}`).test(cartItem.ProductType());
    });
};

CartItemsViewModel.prototype.updateCartItems = function (items) {
    this.CartItems(
        ko.utils.arrayMap(
            items,
            function (item) {
                return cartItemViewModelFactory(item, this.customerIsSmartPrimeEligible, this.onUpdateCallback);
            }.bind(this)
        )
    );
    $(document).trigger('cartChange');
    this.setFocusOnChange();
};

CartItemsViewModel.prototype.setFocusOnChange = function () {
    const updatedInput = this.currentFocus();

    if (updatedInput) {
        document.getElementById(updatedInput)?.focus();
    }
};

CartItemsViewModel.prototype.getCurrentFocus = function (data, event) {
    this.currentFocus(event.target.id);
};

CartItemsViewModel.prototype.removeCartItem = function (cartItem) {
    let index;

    if (!cartItem.isSupply) {
        const supplement = this.CartItems()
            .filter(item => !item.isSupply)
            .find(item => item.SupplementViewModels().some(sup => sup.ItemId() === cartItem.ItemId()));
        const supplementIndex = supplement.SupplementViewModels.indexOf(cartItem);
        index = this.CartItems.indexOf(supplement);

        supplement.SupplementViewModels.remove(cartItem);

        if (!supplement.SupplementViewModels().length) {
            this.CartItems.remove(supplement);
        }

        return {
            item: cartItem,
            parent: supplement,
            revert: () => {
                const hasSupplements = supplement.SupplementViewModels().length;

                supplement.SupplementViewModels.splice(supplementIndex, 0, cartItem);

                if (!hasSupplements) {
                    this.CartItems.splice(index, 0, supplement);
                }
            }
        };
    }

    index = this.CartItems.indexOf(cartItem);
    this.CartItems.remove(cartItem);

    return {
        item: cartItem,
        parent: undefined,
        revert: () => this.CartItems.splice(index, 0, cartItem)
    };
};

CartItemsViewModel.prototype.removeOrMoveItem = function (api, dataFormatter, onSuccess) {
    return cartItem => {
        const {revert, item, parent} = this.removeCartItem(cartItem);
        let removedItem = ko.toJS(item);

        this.isRemovingItem(true);

        if (!cartItem.isSupply && !!parent) {
            const unwrapperParent = ko.toJS(parent);

            unwrapperParent.SupplementViewModels = [removedItem];

            removedItem = unwrapperParent;
        }

        api(dataFormatter(cartItem)).always(response => {
            $(document).trigger('cartChange');
            this.isRemovingItem(false);

            if (response.Status !== HTTP_STATUS_NOCONTENT && response.Status !== HTTP_STATUS_OK) {
                revert();
                return;
            }

            if (typeof onSuccess === 'function') {
                onSuccess(response.Content);
            }

            events.removeCartItem({
                id: cartItem.ProductClassId(),
                sku: cartItem.ProductId(),
                quantity: cartItem.Quantity()
            });

            spRemoveFromCart(formatCartItemsForEvents([removedItem]));

            this.onUpdateCallback();
            smartPak.recentlyViewedProducts.loadBvReviewStars('.cartReviewStars');
        });
    };
};

function invalidSupplyAutoShipItem(cartItem) {
    return cartItem.isSupply && !cartItem.isAutoShipValid();
}

export default CartItemsViewModel;
